// UserClockIcon.jsx (ou dentro do arquivo mesmo)
import React from "react";

const UserClockIcon = ({
    size = 16,
    stroke = "currentColor",
    strokeWidth = 2,
    title = "Aguardando primeiro atendimento",
    className = "",
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label={title}
        className={className}
    >
        <title>{title}</title>

        {/* Usuário (cabeça) */}
        <path
            d="M9 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Usuário (ombros) */}
        <path
            d="M2.5 20.5c.8-3.6 4-6 7.5-6 1.4 0 2.7.4 3.8 1"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Relógio (círculo) */}
        <path
            d="M18 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Ponteiros */}
        <path
            d="M18 14v3l2 1"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default UserClockIcon;
